(function () {
  'use strict';

  angular.module('sempraWebapp').factory('UserGroupsByDateViewModel', userGroupsByDateViewModelFactory);

  /** @ngInject */
  function userGroupsByDateViewModelFactory(reportActions, localeFilters, reportsFilterStore, $translate, dispatcher, ActionTypesEnum) {
    function UserGroupsByDateViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: 'bar',
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      this.chartType = 'TOTAL_USERS_BY_GROUP_VISITS_UNIT';

      init.call(this);
    }

    UserGroupsByDateViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return UserGroupsByDateViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();
      that.total = 0;
      that.totalByGroupName = [];
      reportActions.getTotalUsersByGroupsAndDate(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
        successData.groupTotal.forEach(function (item, index) {
          that.total += item;

          that.totalByGroupName.push({
            total: item,
            name: successData.groupNames[index]
          });
        });
        successData.unit = $translate.instant('TOTAL_USERS_BY_GROUP_USERS_UNIT');
        that.chart.data = successData;
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }
  }
})();
